import PropTypes from 'prop-types';
import React from 'react';


export default function UI5_PillBox(props:any) {

    // {label, palette,  className}

    const palette       = _.get(props, 'palette', 'project') // project or status
    const color         = _.get(props, 'color', false)
    const size          = _.get(props, 'size', 26)

    let bgClass : any         = false
    let borderClass : any    = false

    if (color) {
        switch (palette) {
            case 'project':
                bgClass     = "gd-c-bgp-"+color
                borderClass = "gd-c-pale-border-"+ color
                break
        }
    }

    const classes = Classes(
        "ui5-pillbox",
        bgClass,
        borderClass,
        props.className,
        {
            'pale-bg'       : !!(color),
            's22'           : size === 22,
            's26'           : size === 26,
        }
    );

    return (
        <div className={classes} onClick={props.onClick}>
            {props.label}
            {props.children}
        </div>
    )


}

